module.exports = __webpack_public_path__ + "img/32.b7b8d752.webp";